import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON, useMap } from 'react-leaflet';
import { Icon } from 'leaflet';
import markerIconPng from 'leaflet/dist/images/marker-icon.png';
import neighborhoodsData from 'assets/map/KC-neighborhood-outline.json';
import NearbyPlacesComponent from './api';
import { Grid, MenuItem, TextField, Box, IconButton, Drawer, useMediaQuery  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import parksIcon from 'assets/images/map/park-2.svg';
import libraryIcon from 'assets/images/map/library-book-svgrepo-com.svg';
import schoolsIcon from 'assets/images/map/school-satchel.svg';
import daycareIcon from 'assets/images/map/baby-svgrepo-com.svg';
import universityIcon from 'assets/images/map/university-svgrepo-com.svg';
import resturantsIcon from 'assets/images/map/burder-fast-food-drink.svg';
import hospitalsIcon from 'assets/images/map/map-hospital.svg';
import worshipsIcon from 'assets/images/map/cross.svg';
import socialIcon from 'assets/images/map/cross.svg';
import busIcon from 'assets/images/map/bus-stop-svgrepo-com.svg';
import alcoholIcon from 'assets/images/map/alcohol-svgrepo-com.svg';
import barIcon from 'assets/images/map/alcohol-beverage-drink-svgrepo-com.svg';
import gasStationIcon from 'assets/images/map/gas-station-svgrepo-com.svg';
import publicIcon from 'assets/images/map/government-building-svgrepo-com.svg';

function MyComponent({ hoveredFeature }) {
  return hoveredFeature ? (
    <Popup position={hoveredFeature.latlng}>
      Neighborhood: {hoveredFeature.name}
    </Popup>
  ) : null;
}

const geoJSONStyle = {
  color: 'black',
  weight: 1,
  fillColor: 'white',
  fillOpacity: 0.2,
};

const OpenStreetMap = () => {
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [showNearbyPlaces, setShowNearbyPlaces] = useState(false);
  const [clickedLatLng, setClickedLatLng] = useState(null);
  const [selectedNeighborhood, setSelectedNeighborhood] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [neighborhoodOptions, setNeighborhoodOptions] = useState([]);
  const [mapCenter, setMapCenter] = useState([39.099724, -94.578331]);
  const [centerMap, setCenterMap] = useState(false);
  const [mapZoom, setMapZoom] = useState(13);
  const [mapQueryData, setMapQueryData] = useState(null);
  const [layersGeoJSON, setLayersGeoJSON] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  // const markerRef = useRef(); // Create a ref for the marker

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  // Set dynamic width based on screen size
  const drawerWidth = isMobile ? '100vw' : isTablet ? '50vw' : '30vw';


  function convertToGeoJSON(mapQueryData) {
    if (!mapQueryData) {
      console.error('No data provided');
      return null;
    }
  
    const featureTypes = ['parks', 'restaurants', 'hospitals', 'schools', 'daycare', 'university', 'placeOfWorships', 'buses', 'alcohol', 'bars', 'gasStations', 'socialFacility', 'library', 'publicBuilding'];
  
    const geoJSONObjects = {};

    featureTypes.forEach(type => {
      const features = mapQueryData[type];
      if (!features || features.length === 0) {
        console.log(`No ${type} data available`);
        geoJSONObjects[type] = null;
        return;
      }
  
      const geojson = {
        type: "FeatureCollection",
        features: features.map(feature => {
          if (!feature || !feature.data || !feature.data.geometry) {
            return {
              type: "Feature",
              properties: {},
              geometry: null
            };
          }
  
          const coordinates = feature.data.geometry.reduce((acc, geom) => {
            if (geom && typeof geom.lat === 'number' && typeof geom.lon === 'number') {
              acc.push([geom.lon, geom.lat]);
            }
            return acc;
          }, []);
  
          if (coordinates.length > 0 && (coordinates[0][0] !== coordinates[coordinates.length - 1][0] || coordinates[0][1] !== coordinates[coordinates.length - 1][1])) {
            coordinates.push(coordinates[0]);
          }
  
          return {
            type: "Feature",
            properties: {
              name: feature.name,
              id: feature.data.id,
              tags: feature.data.tags,
              ...(mapQueryData.selectedAttribute
                ? { [mapQueryData.selectedAttribute.name]: mapQueryData.selectedAttribute.value }
                : {}),
            },
            geometry: {
              type: "Polygon",
              coordinates: [coordinates]
            }
          };
        }).filter(feature => feature.geometry !== null && feature.geometry.coordinates.length > 0)
      };
  
      geoJSONObjects[type] = geojson;
    });
  
    return geoJSONObjects;
  }
  

  const recreationStyle = {
    color: 'green',
    weight: 3,    
    fillColor: 'lightgreen', 
    fillOpacity: 0.5,      
  };

  const socialStyle = {
    color: 'brown',
    weight: 3,    
    fillColor: 'lightbrown', 
    fillOpacity: 0.5,      
  };

  const restaurantStyle = {
    color: 'blue',
    weight: 3,    
    fillColor: 'lightblue', 
    fillOpacity: 0.5,      
  };

  const schoolStyle = {
    color: 'orange',
    weight: 3,    
    fillColor: 'lightorange', 
    fillOpacity: 0.5,      
  };

  const hospitalStyle = {
    color: 'red',
    weight: 3,    
    fillColor: 'lightred', 
    fillOpacity: 0.5,      
  };

  const busStyle = {
    color: 'grey',
    weight: 3,    
    fillColor: 'lightgrey', 
    fillOpacity: 0.5,      
  };

  const storeStyle = {
    color: 'purple',
    weight: 3,    
    fillColor: 'lightpurple', 
    fillOpacity: 0.5,      
  };

  const publicStyle = {
    color: 'yellow',
    weight: 3,    
    fillColor: 'lightyellow', 
    fillOpacity: 0.5,      
  };


  const getRegionStyle = (feature) => {
    if (!selectedAttribute) {
      return geoJSONStyle; // Default style if no attribute is selected
    }
  
    const value = feature.properties[selectedAttribute.name];
    let fillColor;
  
    // Example: Define color ranges based on value
    if (value <= 10) {
      fillColor = 'lightblue';
    } else if (value <= 20) {
      fillColor = 'yellow';
    } else if (value <= 50) {
      fillColor = 'orange';
    } else {
      fillColor = 'red';
    }
  
    return {
      color: 'black',
      weight: 1,
      fillColor: fillColor,
      fillOpacity: 0.7,
    };
  };
  



  const receiveMapQueryData = (data) => {
    console.log('Data received from child:', data);
    setMapQueryData(data);
    const geoJSON = convertToGeoJSON(data);

    if (data.selectedAttribute) {
      setSelectedAttribute(data.selectedAttribute);
    }

    if (geoJSON) {
      setLayersGeoJSON(geoJSON);
    } else {
      console.log('GeoJSON conversion failed');
      setLayersGeoJSON(null);
    } 
  };

  const handleMousemove = (e) => {
    const layer = e.target;
    setHoveredFeature({
      latlng: e.latlng,
      name: layer.feature.properties.nbhname,
    });
  };

  const handleMouseout = () => {
    setHoveredFeature(null);
  };

  const handleClick = (e) => {
    setShowNearbyPlaces(true);
    setSelectedNeighborhood('');
    setClickedLatLng(e.latlng);
    const layer = e.target;
    console.log("lat long clicked:", e.latlng)
    console.log("Feature clicked:", layer.feature.properties.nbhname);

    setNeighborhood(layer.feature.properties.nbhname);
    setMapCenter([e.latlng.lat, e.latlng.lng]);
    setMapZoom(15);
    setCenterMap(true);
    // markerRef.current.openPopup();
  };

  const onEachFeature = (feature, layer) => {
    layer.on({
      mousemove: handleMousemove,
      mouseout: handleMouseout,
      click: handleClick,
    });
  };

  useEffect(() => {
    const options = neighborhoodsData.features.map(feature => ({
      name: feature.properties.nbhname,
      coordinates: feature.geometry.coordinates[0][0],
      center: findNeighborhoodCenter(feature.geometry.coordinates[0][0])
    }));
    options.sort((a, b) => {
      if (a.name === null && b.name === null) return 0;
      if (a.name === null) return 1;
      if (b.name === null) return -1;

      return a.name.localeCompare(b.name);
    });
    setNeighborhoodOptions(options);
    // console.log(mapQueryData);
  }, [mapQueryData]);

  const handleNeighborhoodSelect = (neighborhood) => {
    let nCenter = neighborhoodOptions.find(option => option.name === neighborhood).center
    setShowNearbyPlaces(false);
    setSelectedNeighborhood(neighborhood);
    setMapCenter([nCenter.lat, nCenter.lon]);
    setMapZoom(15);
    setNeighborhood(neighborhood);
    setCenterMap(true);
    // markerRef.current.openPopup();
  };

  const findNeighborhoodCenter = (neighborhoodPolygon) => {
    let x = 0, y = 0, n = neighborhoodPolygon.length;
    neighborhoodPolygon.forEach(point => {
      x += point[0];
      y += point[1];
    });
    return { lat: y / n, lon: x / n };
  };

  function ChangeView({ center, zoom }) {
    const map = useMap();
    if (centerMap) {
      map.setView(center, zoom);
      setCenterMap(false);
    }
    return null;
  }

  return (
    <Box>
      <Grid item>
        <TextField
          select
          value={selectedNeighborhood}
          label="Select a Neighborhood"
          fullWidth
          sx={{ marginBottom: '10px' }}
          onChange={(e) => handleNeighborhoodSelect(e.target.value)}
        >
          {neighborhoodOptions.map((option, index) => (
            <MenuItem key={index} value={option.name}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Box className="map-container">
        <Box className="map">
          <MapContainer center={mapCenter} zoom={mapZoom} scrollWheelZoom>
            <ChangeView center={mapCenter} zoom={mapZoom} />
            <TileLayer
              url="https://tile-{s}.openstreetmap.fr/hot/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://www.openstreetmap.fr/">OpenStreetMap France</a>'
            />
            <Marker position={mapCenter} icon={new Icon({ iconUrl: markerIconPng, iconSize: [20, 30], iconAnchor: [12, 41] })}>
              <Popup>{neighborhood}</Popup>
            </Marker>
            <GeoJSON data={neighborhoodsData} style={geoJSONStyle} onEachFeature={onEachFeature} />
            <MyComponent hoveredFeature={hoveredFeature} />
            
            {mapQueryData && mapQueryData.showIcons.restaurants && mapQueryData.restaurants.map((restaurant, index) => (
              <Marker key={`restaurant-${index}`} position={[restaurant.latitude, restaurant.longitude]} icon={new Icon({ iconUrl: resturantsIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{restaurant.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.hospitals && mapQueryData.hospitals.map((hospital, index) => (
              <Marker key={`hospital-${index}`} position={[hospital.latitude, hospital.longitude]} icon={new Icon({ iconUrl: hospitalsIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{hospital.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.schools && mapQueryData.schools.map((school, index) => (
              <Marker key={`school-${index}`} position={[school.latitude, school.longitude]} icon={new Icon({ iconUrl: schoolsIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{school.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.daycare && mapQueryData.schools.map((daycare, index) => (
              <Marker key={`daycare-${index}`} position={[daycare.latitude, daycare.longitude]} icon={new Icon({ iconUrl: daycareIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{daycare.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.university && mapQueryData.university.map((university, index) => (
              <Marker key={`university-${index}`} position={[university.latitude, university.longitude]} icon={new Icon({ iconUrl: universityIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{university.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.placeOfWorships && mapQueryData.placeOfWorships.map((placeOfWorship, index) => (
              <Marker key={`placeOfWorship-${index}`} position={[placeOfWorship.latitude, placeOfWorship.longitude]} icon={new Icon({ iconUrl: worshipsIcon, iconSize: [20, 30], iconAnchor: [12, 41] })}>
                <Popup>{placeOfWorship.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.socialFacility && mapQueryData.socialFacility.map((socialFacility, index) => (
              <Marker key={`socialFacility-${index}`} position={[socialFacility.latitude, socialFacility.longitude]} icon={new Icon({ iconUrl: socialIcon, iconSize: [20, 30], iconAnchor: [12, 41] })}>
                <Popup>{socialFacility.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.parks && mapQueryData.parks.map((park, index) => (
              <Marker key={`park-${index}`} position={[park.latitude, park.longitude]} icon={new Icon({ iconUrl: parksIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{park.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.library && mapQueryData.library.map((library, index) => (
              <Marker key={`library-${index}`} position={[library.latitude, library.longitude]} icon={new Icon({ iconUrl: libraryIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{library.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.buses && mapQueryData.buses.map((bus, index) => (
              <Marker key={`bus-${index}`} position={[bus.latitude, bus.longitude]} icon={new Icon({ iconUrl: busIcon, iconSize: [20, 30], iconAnchor: [12, 41] })}>
                <Popup>{bus.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.alcohol && mapQueryData.alcohol.map((alcohol, index) => (
              <Marker key={`alcohol-${index}`} position={[alcohol.latitude, alcohol.longitude]} icon={new Icon({ iconUrl: alcoholIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{alcohol.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.bars && mapQueryData.bars.map((bar, index) => (
              <Marker key={`bar-${index}`} position={[bar.latitude, bar.longitude]} icon={new Icon({ iconUrl: barIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{bar.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.gasStations && mapQueryData.gasStations.map((gasStation, index) => (
              <Marker key={`gasStation-${index}`} position={[gasStation.latitude, gasStation.longitude]} icon={new Icon({ iconUrl: gasStationIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{gasStation.name}</Popup>
              </Marker>
            ))}

            {mapQueryData && mapQueryData.showIcons.publicBuilding && mapQueryData.publicBuilding.map((publicBuilding, index) => (
              <Marker key={`publicBuilding-${index}`} position={[publicBuilding.latitude, publicBuilding.longitude]} icon={new Icon({ iconUrl: publicIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
                <Popup>{publicBuilding.name}</Popup>
              </Marker>
            ))}



            {mapQueryData && mapQueryData.showLayer.parks && mapQueryData.parks && (
              <GeoJSON key={JSON.stringify(mapQueryData.parks)} data={layersGeoJSON['parks']} style={recreationStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.library && mapQueryData.library && (
              <GeoJSON key={JSON.stringify(mapQueryData.library)} data={layersGeoJSON['library']} style={recreationStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.restaurants && mapQueryData.restaurants && (
              <GeoJSON key={JSON.stringify(mapQueryData.restaurants)} data={layersGeoJSON['resturants']} style={restaurantStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.bars && mapQueryData.bars && (
              <GeoJSON key={JSON.stringify(mapQueryData.bars)} data={layersGeoJSON['bars']} style={restaurantStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.hospitals && mapQueryData.hospitals && (
              <GeoJSON key={JSON.stringify(mapQueryData.hospitals)} data={layersGeoJSON['hospitals']} style={hospitalStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.schools && mapQueryData.schools && (
              <GeoJSON key={JSON.stringify(mapQueryData.schools)} data={layersGeoJSON['schools']} style={schoolStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.daycare && mapQueryData.daycare && (
              <GeoJSON key={JSON.stringify(mapQueryData.daycare)} data={layersGeoJSON['daycare']} style={schoolStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.university && mapQueryData.university && (
              <GeoJSON key={JSON.stringify(mapQueryData.university)} data={layersGeoJSON['university']} style={schoolStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.placeOfWorships && mapQueryData.placeOfWorships && (
              <GeoJSON key={JSON.stringify(mapQueryData.placeOfWorships)} data={layersGeoJSON['placeOfWorships']} style={socialStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.socialFacility && mapQueryData.socialFacility && (
              <GeoJSON key={JSON.stringify(mapQueryData.socialFacility)} data={layersGeoJSON['socialFacility']} style={socialStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.buses && mapQueryData.buses && (
              <GeoJSON key={JSON.stringify(mapQueryData.buses)} data={layersGeoJSON['buses']} style={busStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.alcohol && mapQueryData.alcohol && (
              <GeoJSON key={JSON.stringify(mapQueryData.alcohol)} data={layersGeoJSON['alcohol']} style={storeStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.gasStations && mapQueryData.gasStations && (
              <GeoJSON key={JSON.stringify(mapQueryData.gasStations)} data={layersGeoJSON['gasStations']} style={storeStyle} />
            )}

            {mapQueryData && mapQueryData.showLayer.publicBuilding && mapQueryData.publicBuilding && (
              <GeoJSON key={JSON.stringify(mapQueryData.publicBuilding)} data={layersGeoJSON['publicBuilding']} style={publicStyle} />
            )}


            <GeoJSON
              data={neighborhoodsData}
              style={(feature) => getRegionStyle(feature)}
              onEachFeature={onEachFeature}
            />

          </MapContainer>
        </Box>

        {/* Sidebar Drawer */}
        <Drawer
          anchor="right"
          open={showNearbyPlaces || selectedNeighborhood !== ''}
          onClose={() => { setShowNearbyPlaces(false); setSelectedNeighborhood(''); }}
          PaperProps={{
            sx: {
              width: drawerWidth,
            },
          }}
        >
          <Box sx={{ padding: 2 }}>
            <IconButton
              onClick={() => { setShowNearbyPlaces(false); setSelectedNeighborhood(''); }}
              aria-label="close"
              sx={{ alignSelf: 'flex-end' }}
            >
              <CloseIcon />
            </IconButton>

            {selectedNeighborhood ? (
              <NearbyPlacesComponent
                lat={neighborhoodOptions.find(option => option.name === selectedNeighborhood)?.center.lat}
                lng={neighborhoodOptions.find(option => option.name === selectedNeighborhood)?.center.lon}
                mapData={receiveMapQueryData}
              />
            ) : showNearbyPlaces && (
              <NearbyPlacesComponent
                lat={clickedLatLng.lat}
                lng={clickedLatLng.lng}
                mapData={receiveMapQueryData}
              />
            )}
          </Box>
        </Drawer>
      </Box>
    </Box>
    // <div>
    //   <Grid item>
    //     <TextField select value={selectedNeighborhood} label="Select a Neighborhood" style={{ display:'flex'}} sx={{ marginBottom: '10px' }} onChange={(e) => handleNeighborhoodSelect(e.target.value)}>
    //       {neighborhoodOptions.map((option, index) => (
    //         <MenuItem key={index} value={option.name}>
    //           {option.name}
    //         </MenuItem>
    //       ))}
    //     </TextField>
    //   </Grid>

    //   <div className="map-container" >
    //     <div className="map">
    //       <MapContainer center={mapCenter} zoom={mapZoom} scrollWheelZoom={true}>
    //         <ChangeView center={mapCenter} zoom={mapZoom} />
    //         <TileLayer url="https://tile-{s}.openstreetmap.fr/hot/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://www.openstreetmap.fr/">OpenStreetMap France</a>'
    //         />
    //         <Marker position={mapCenter} icon={new Icon({ iconUrl: markerIconPng, iconSize: [20, 30], iconAnchor: [12, 41] })}>
    //           <Popup>{neighborhood}</Popup>
    //         </Marker>
    //         <GeoJSON data={neighborhoodsData} style={geoJSONStyle} onEachFeature={onEachFeature} />
    //         <MyComponent hoveredFeature={hoveredFeature} />
    //         {mapQueryData && mapQueryData.showIcons.restaurants && mapQueryData.restaurants && mapQueryData.restaurants.map((restaurant, index) => (
    //           <Marker key={`restaurant-${index}`} position={[restaurant.latitude, restaurant.longitude]} icon={new Icon({ iconUrl: resturantsIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
    //             <Popup>{restaurant.name}</Popup>
    //           </Marker>
    //         ))}
    //         {mapQueryData && mapQueryData.showIcons.hospitals && mapQueryData.hospitals && mapQueryData.hospitals.map((hospital, index) => (
    //           <Marker key={`hospital-${index}`} position={[hospital.latitude, hospital.longitude]} icon={new Icon({ iconUrl: hospitalsIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
    //             <Popup>{hospital.name}</Popup>
    //           </Marker>
    //         ))}
    //         {mapQueryData && mapQueryData.showIcons.schools && mapQueryData.schools && mapQueryData.schools.map((school, index) => (
    //           <Marker key={`school-${index}`} position={[school.latitude, school.longitude]} icon={new Icon({ iconUrl: schoolsIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
    //             <Popup>{school.name}</Popup>
    //           </Marker>
    //         ))}
    //         {mapQueryData && mapQueryData.showIcons.placeOfWorships && mapQueryData.placeOfWorships && mapQueryData.placeOfWorships.map((placeOfWorship, index) => (
    //           <Marker key={`placeOfWorship-${index}`} position={[placeOfWorship.latitude, placeOfWorship.longitude]} icon={new Icon({ iconUrl: worshipsIcon, iconSize: [20, 30], iconAnchor: [12, 41] })}>
    //             <Popup>{placeOfWorship.name}</Popup>
    //           </Marker>
    //         ))}
    //         {mapQueryData && mapQueryData.showIcons.parks && mapQueryData.parks && mapQueryData.parks.map((park, index) => (
    //           <Marker key={`park-${index}`} position={[park.latitude, park.longitude]} icon={new Icon({ iconUrl: parksIcon, iconSize: [30, 40], iconAnchor: [12, 41] })}>
    //             <Popup>{park.name}</Popup>
    //           </Marker>
    //         ))}
    //         {mapQueryData && mapQueryData.showLayer.parks && mapQueryData.parks && (
    //           <GeoJSON key={JSON.stringify(mapQueryData.parks)} data={layersGeoJSON['parks']} style={parkStyle} />
    //         )}
    //         {mapQueryData && mapQueryData.showLayer.restaurants && mapQueryData.restaurants && (
    //           <GeoJSON key={JSON.stringify(mapQueryData.restaurants)} data={layersGeoJSON['resturants']} style={restaurantStyle} />
    //         )}
    //         {mapQueryData && mapQueryData.showLayer.hospitals && mapQueryData.hospitals && (
    //           <GeoJSON key={JSON.stringify(mapQueryData.hospitals)} data={layersGeoJSON['hospitals']} style={hospitalStyle} />
    //         )}
    //         {mapQueryData && mapQueryData.showLayer.schools && mapQueryData.schools && (
    //           <GeoJSON key={JSON.stringify(mapQueryData.schools)} data={layersGeoJSON['schools']} style={schoolStyle} />
    //         )}
    //         {mapQueryData && mapQueryData.showLayer.placeOfWorships && mapQueryData.placeOfWorships && (
    //           <GeoJSON key={JSON.stringify(mapQueryData.placeOfWorships)} data={layersGeoJSON['placeOfWorships']} style={worshipStyle} />
    //         )}
    //       </MapContainer>
    //     </div>
    //     {selectedNeighborhood && (
    //       <div className="sidebar">
    //         <NearbyPlacesComponent
    //           lat={neighborhoodOptions.find(option => option.name === selectedNeighborhood)?.center.lat}
    //           lng={neighborhoodOptions.find(option => option.name === selectedNeighborhood)?.center.lon}
    //           mapData={receiveMapQueryData}
    //         />
    //       </div>
    //     )}
    //     {showNearbyPlaces &&
    //       <div className="sidebar"><NearbyPlacesComponent lat={clickedLatLng.lat} lng={clickedLatLng.lng} mapData={receiveMapQueryData} /></div>}
    //   </div>
    // </div>
  );
};

export default OpenStreetMap;
